import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const Inv4110SearchParamsSchema = z
  .object({
    itemId: z.coerce.string().optional(), // this value was used in `Select` component, so it should be string
    lotNo: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv4110SearchParams = z.infer<typeof Inv4110SearchParamsSchema>

//==============================================================

export const Inv4110SearchResultItemSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  availableQty: z.number(),
  reservedQty: z.number(),
  productionQty: z.number(),
  rejectedQty: z.number(),
  qmsQty: z.number(),
})
export type Inv4110SearchResultItem = z.infer<
  typeof Inv4110SearchResultItemSchema
>

//==============================================================

export const Inv4110SearchResultSchema = z
  .object({
    data: z.array(Inv4110SearchResultItemSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv4110SearchResult = z.infer<typeof Inv4110SearchResultSchema>

//==============================================================
// for fetching locations
export const Inv4110LocationListItemSchema = z.object({
  location: z.string(),
  status: z.string(),
  qty: z.number(),
})
export type Inv4110LocationListItem = z.infer<
  typeof Inv4110LocationListItemSchema
>

export const Inv4110LocationListSchema = z.object({
  id: z.number(),
  locations: z.array(Inv4110LocationListItemSchema),
})
export type Inv4110LocationList = z.infer<typeof Inv4110LocationListSchema>

//==============================================================
